export default "__VITE_ASSET__CvJrvl0Y__"